import { OrderFormData, TradeType } from '@eih-netbroker/common';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { NbButton } from '../../../../../shared/components/button/Button';
import { OrderFormSourceComponent } from '../../../types/orderTypes';
import { useOrderState } from '../../OrderStateContext';
import { OrderFooterPrimaryButton } from './OrderFooterPrimaryButton';
import { OrderFooterSecondaryButton } from './OrderFooterSecondaryButton';
import classes from './OrderModalBottomNavigationButtons.module.scss';

type OrderModalBottomNavigationButtonsProps = {
  orderRequestLoading: boolean;
  isOrderFormInvalid: boolean;
  orderState: OrderFormData;
  sourceComponent?: OrderFormSourceComponent;
  onConfirmHandle: () => Promise<void>;
  onContinue: () => void;
  onCancel: (shouldResetFormToDefaults: boolean) => void;
  onBack: (shouldResetFormToDefaults: boolean) => void;
};

export const OrderModalBottomNavigationButtons = ({
  orderRequestLoading,
  onCancel,
  isOrderFormInvalid,
  orderState,
  onConfirmHandle,
  onContinue,
  onBack,
  sourceComponent,
}: OrderModalBottomNavigationButtonsProps) => {
  const { translation } = useLocale();
  const { tempOrder, warnings } = useOrderState();

  const primaryButtonText =
    orderState.tradeType === TradeType.Buy
      ? translation.orderModal.bottomNavigation.overviewBuy
      : translation.orderModal.bottomNavigation.overviewSell;

  // Handle order init separately to handle validation and disabled state
  if (!tempOrder && !warnings) {
    return (
      <div className={classes.orderButtons}>
        <NbButton
          isLoading={orderRequestLoading}
          fullWidth
          size="medium"
          disabled={isOrderFormInvalid}
          onClick={onConfirmHandle}
          data-testid="order-modal-confirm-button"
          className={classes.button}
        >
          {primaryButtonText}
        </NbButton>
      </div>
    );
  }

  return (
    <div className={classes.orderButtons}>
      <OrderFooterSecondaryButton
        isLoading={orderRequestLoading}
        tempOrder={tempOrder}
        warnings={warnings}
        onBack={onBack}
        onClose={onCancel}
        sourceComponent={sourceComponent}
      />
      <OrderFooterPrimaryButton
        isLoading={orderRequestLoading}
        tempOrder={tempOrder}
        warnings={warnings}
        onClose={onCancel}
        onBack={onBack}
        onContinue={onContinue}
        orderState={orderState}
      />
    </div>
  );
};
